module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/app-784a79b00d1827df977d63ddf01e9adc.jpg";